import { createContext, useContext, useReducer } from "react";
import { ACTION_TYPES, CustomPageReducer, CustomPageState } from "./custom-page-reducer";

const CustomPageContext = createContext<CustomPageState | undefined>(undefined);
const CustomPageDispatchContext = createContext({} as any);

const initialState: CustomPageState = {
    detail: undefined,
    page: undefined,
    loading: true,
    error: null,
};

const CustomPageProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(CustomPageReducer, initialState);

    return (
        <CustomPageContext.Provider value={state}>
            <CustomPageDispatchContext.Provider value={dispatch}>
                {children}
            </CustomPageDispatchContext.Provider>
        </CustomPageContext.Provider>
    );
};

const useCustomPageState = () => {
    const context = useContext(CustomPageContext);
    if (context === undefined) {
        throw new Error('useCustomPageState must be used within a CustomPageProvider');
    }
    return context;
};

const useCustomPageDispatch = () => {
    const context = useContext(CustomPageDispatchContext);
    if (context === undefined) {
        throw new Error('useCustomPageDispatch must be used within a CustomPageProvider');
    }
    return context;
};

export { CustomPageProvider, useCustomPageState, useCustomPageDispatch, ACTION_TYPES };
